import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import isFinite from 'lodash/isFinite';
import PropTypes from 'prop-types';

import Format from '~/lib/format';
import {LOCATION_TEXT} from '~/types/rob';

import sy from '~/styles';
import {Text, Pressable, Dialog, FormNumberInput} from '~/components/controls';

const TireProfile = ({style, location, widths, onChange}) => {
  const [values, setValues] = useState(widths);
  const [showEdit, setShowEdit] = useState(null);

  useEffect(() => {
    if (showEdit) {
      setValues(widths);
    }
  }, [showEdit]);

  return (
    <>
      <View style={style}>
        <Pressable
          style={[
            sy['bg-gray95'],
            {
              width: 24,
              height: 24,
              borderRadius: 2,
              alignItems: 'center',
              justifyContent: 'center',
            },
          ]}
          onPress={() => setShowEdit(true)}>
          <Text style={sy.xSmallMedium}>
            {isFinite(widths?.[location]) ? (
              Format.number(widths?.[location], 1, false)
            ) : (
              <>?</>
            )}
          </Text>
        </Pressable>
      </View>
      {showEdit && (
        <Dialog
          visible={true}
          title="Bandprofiel"
          onDismiss={() => setShowEdit(false)}
          buttons={[
            {
              text: 'Annuleren',
              onPress: () => setShowEdit(false),
            },
            {
              text: 'OK',
              onPress: () => {
                onChange(values);
                setShowEdit(false);
              },
            },
          ]}>
          {Object.keys(widths).map((location) => (
            <View style={[sy['py-4']]} key={location}>
              <FormNumberInput
                label={`${LOCATION_TEXT[location] ?? location} (mm)`}
                value={widths[location]}
                digits={1}
                onChangeNumber={(val) => {
                  if (!isFinite(val)) {
                    return;
                  }

                  setValues({
                    ...values,
                    [location]: val,
                  });
                }}
              />
            </View>
          ))}
        </Dialog>
      )}
    </>
  );
};

TireProfile.propTypes = {
  style: PropTypes.any,
  location: PropTypes.any,
  widths: PropTypes.object,
  onChange: PropTypes.func,
};

export default TireProfile;
